export const DEFAULT_HOMEPAGE_STUDIO = {
  eyebrow: 'O estúdio',
  title: 'O museu como lugar de preservação, educação e cidadania',
  paragraph_one: 'A preservação do patrimônio histórico, artístico e natural deve se constituir em uma prioridade para a gestão pública. Entendemos os museus como cenário próprio das ações de preservação, educação e exposição, que potencializam os destinos turísticos.',
  paragraph_two: 'Nossa proposta se associa aos conceitos da Política Nacional de Museus (IBRAM, 2009), que entende o patrimônio cultural brasileiro como instrumento de inclusão social e cidadania.',
  image_url: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1200&q=80',
  image_alt: 'Interior',
  image_caption: 'A Casa do Careta',
  image_location: 'Triunfo, PE, 2019',
};
